import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/admin/opportunity/$opportunityId/contact/$contactId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { opportunityId, contactId } = Route.useParams();
  return (
    <Navigate
      to="/admin/organizations/$organizationId/opportunities/$opportunityId/contacts/$contactId"
      params={{
        organizationId: process.env.CONNECTED_ORGANIZATION_ID,
        opportunityId,
        contactId,
      }}
      replace
    />
  );
}
